module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAICAYAAACYhf2vAAAABHNCSVQICAgIfAhkiAAAAGtJREFUOE/Fk7ENgDAMBO8ngFHSpkJswCYwAkzECqRJ1oEJjCJR0FAGu3ThO8n/Asg5T5JmMwuS+rprPAewxRgPPfC9MfDr/KhSSrUZnARSFTAnOGZ2ugoAl/8L3EP4quECBKD7IRMJWGsNb2/HKeMBvdtZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bar_chart_grey_label.png
// module id = yCo8
// module chunks = 3